import { render, staticRenderFns } from "./MaidClaimStaging.vue?vue&type=template&id=664355e0&"
import script from "./MaidClaimStaging.vue?vue&type=script&lang=js&"
export * from "./MaidClaimStaging.vue?vue&type=script&lang=js&"
import style0 from "./MaidClaimStaging.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MaidClaimStaging.vue"
export default component.exports